import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

let uid = 0;

/**
 * Small square, bordered icon-only button (white bg, rounded corners,
 * tone-colored hover) - the edit/delete style used in list rows.
 */
const SquareIconButton = ({
  icon,
  onClick,
  title,
  id,
  disabled,
  tone,
  active,
  pressed,
}) => {
  const buttonId = useRef(id || `square-icon-btn-${(uid += 1)}`);

  return (
    <>
      <button
        type="button"
        id={buttonId.current}
        className={`square-icon-btn${tone !== 'default' ? ` square-icon-btn--${tone}` : ''}${active ? ' square-icon-btn--active' : ''}`}
        onClick={onClick}
        disabled={disabled}
        // The title is only a tooltip: it names the button for screen
        // readers too
        aria-label={title || undefined}
        aria-pressed={pressed === undefined ? undefined : pressed}
      >
        {icon}
      </button>
      {title && (
        <UncontrolledTooltip placement="bottom" target={buttonId.current}>
          {title}
        </UncontrolledTooltip>
      )}
    </>
  );
};

SquareIconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  tone: PropTypes.oneOf(['default', 'danger', 'primary']),
  // Highlights the button, e.g. a comment button when a comment exists.
  active: PropTypes.bool,
  // For a toggle: whether it's on (left out for ordinary buttons)
  pressed: PropTypes.bool,
};

SquareIconButton.defaultProps = {
  title: '',
  id: undefined,
  disabled: false,
  tone: 'default',
  active: false,
  pressed: undefined,
};

export default SquareIconButton;
